export const inputData = [
   { type: "text", id: "firstName", placeholder: "First Name" },
   { type: "text", id: "lastName", placeholder: "Last Name" },
   { type: "email", id: "email", placeholder: "E-mail" },
   { type: "tel", id: "phone", placeholder: "Phone" },
];

export const homeInput = [
   { type: "text", id: "name", placeholder: "Name" },
   { type: "email", id: "email", placeholder: "E-mail" },
   { type: "tel", id: "phone", placeholder: "Phone" },
   { type: "text", id: "address", placeholder: "Address" },
   { type: "text", id: "subject", placeholder: "Subject" },


];
